import { lazy } from 'react'

export const AppsPageAsync = lazy(() => import('./AppsPage'))
